import { Helmet } from "react-helmet-async";

// Reads GA4 + GSC verification token from env vars at build time.
// Set these in /app/frontend/.env (and your prod env):
//   REACT_APP_GA4_MEASUREMENT_ID=G-XXXXXXXXXX
//   REACT_APP_GSC_VERIFICATION_TOKEN=<token-from-google-search-console>
export default function Analytics() {
  const ga4 = process.env.REACT_APP_GA4_MEASUREMENT_ID;
  const gsc = process.env.REACT_APP_GSC_VERIFICATION_TOKEN;
  if (!ga4 && !gsc) return null;
  return (
    <Helmet>
      {gsc && <meta name="google-site-verification" content={gsc} />}
      {ga4 && (
        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${ga4}`}
        />
      )}
      {ga4 && (
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${ga4}', { anonymize_ip: true });
        `}</script>
      )}
    </Helmet>
  );
}
